import { GetTokenSilentlyOptions } from "@auth0/auth0-spa-js";
import { Observable, of } from "rxjs";

export class Auth0AuthorizationMockService {
    getTokenSilently(options?: GetTokenSilentlyOptions): Observable<string> {
        return of("token");
    }
}
